/**
 * PDP "You may also like": laedt Empfehlungen per Section Rendering API
 * nach (siehe sections/pdp-recommendations.liquid) und lässt die Pfeile
 * per scrollBy scrollen. Der Wechsel gleitet (Alex, Pastel #28, 22.09.: "animate the cards sliding
 * horizontally when clicking on the arrows"); bei prefers-reduced-motion springt er wie zuvor.
 */
(function () {
  var root = document.querySelector('[data-pdp-recommendations]');
  if (!root) return;

  var track = root.querySelector('[data-pdp-recommendations-track]');
  var url = root.getAttribute('data-url');

  if (track && url && !track.children.length) {
    fetch(url)
      .then(function (res) {
        return res.ok ? res.text() : null;
      })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshTrack = doc.querySelector('[data-pdp-recommendations-track]');
        if (freshTrack) track.innerHTML = freshTrack.innerHTML;
      })
      .catch(function () {
        /* still: leave section empty, no recommendations available */
      });
  }

  root.addEventListener('click', function (event) {
    var button = event.target.closest('[data-action]');
    if (!button || !track) return;
    var card = track.firstElementChild;
    var amount = card ? card.getBoundingClientRect().width + 4 : track.clientWidth;
    var direction = button.getAttribute('data-action') === 'prev' ? -1 : 1;
    var noMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: amount * direction, behavior: noMotion ? 'auto' : 'smooth' });
  });
})();
